import { AutomationProvidersEnum } from '..';
import { IActionOption } from './ActionOption';
import { IConditionOption } from './ConditionOption';

export interface IAutomationNodeOptions {
  conditionOptions: IConditionOption[];
  actionOptions: IActionOption[];
}

export interface IAutomationNodeOptionsContext {
  automationId?: string;
  templateId?: string;
  providerName?: AutomationProvidersEnum;
}
